module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am474-d530da05237df82f77fde66504940612.jpg";